<template>
  <v-dialog persistent :value="value" max-width="300">
    <v-card>
      <v-card-title class="headline">
        Save confirmation
      </v-card-title>

      <v-card-text>
        <p>
          Result for sortition
          <span class="font-weight-bold">{{ result.sortition.name }}</span> for
          date <span class="font-weight-bold">{{ date }}</span> is going to be
          saved.
        </p>
        <ul>
          <li v-for="(value, field) in result.fillableFields" :key="field">
            {{ value.name }}:
            <span class="font-weight-bold">{{ result[field] }}</span>
          </li>
        </ul>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="danger" text @click="onCancel">
          Cancel
        </v-btn>

        <v-btn color="success" text @click="onConfirm">
          Yes, save it.
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ResultSaveDialog",
  props: {
    value: {
      type: Boolean,
      required: true
    },
    date: {
      type: String,
      required: true
    },
    result: {
      type: Object,
      required: true
    }
  },
  methods: {
    onCancel() {
      this.$emit("input", false);
      this.$emit("cancel");
    },
    onConfirm() {
      this.$emit("input", false);
      this.$emit("confirm");
    }
  }
};
</script>

<style scoped>
p {
  font-size: 1rem;
}
li {
  font-size: 1.5rem;
  margin: 10px 0;
}
</style>
